import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiTarget, FiCheckCircle, FiAlertTriangle, FiMinus } = FiIcons;

const resultConfig = {
  'Reported': { icon: FiCheckCircle, cls: 'text-emerald-600', bg: 'bg-emerald-50 border-emerald-100' },
  'Clicked': { icon: FiAlertTriangle, cls: 'text-orange-500', bg: 'bg-orange-50 border-orange-100' },
  'Sent': { icon: FiMinus, cls: 'text-slate-400', bg: 'bg-slate-50 border-slate-100' },
  'Opened': { icon: FiMinus, cls: 'text-slate-500', bg: 'bg-slate-50 border-slate-100' },
};

const PhishingHistory = ({ learnerId, recipients = [], simulations = [] }) => {
  const incidents = recipients.map(r => {
    const s = simulations.find(sim => String(sim.id) === String(r.campaign_id));
    return {
      ...r,
      simulationName: s?.name || 'Simulation Test',
      date: s?.date || r.sent_at || 'Unknown'
    };
  }).sort((a,b) => new Date(b.date) - new Date(a.date));

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
      <h3 className="text-sm font-semibold text-slate-700 mb-4 flex items-center gap-2">
        <SafeIcon icon={FiTarget} className="text-orange-500" /> Phishing Simulation History
      </h3>
      {incidents.length === 0 ? (
        <p className="text-sm text-slate-400">No phishing simulation events recorded.</p>
      ) : (
        <div className="space-y-2">
          {incidents.map(e => {
            const cfg = resultConfig[e.status] || resultConfig['Sent'];
            return (
              <div key={e.id} className={`flex items-start gap-3 p-3 rounded-lg border ${cfg.bg}`}>
                <SafeIcon icon={cfg.icon} className={`${cfg.cls} flex-shrink-0 mt-0.5 text-base`} />
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-slate-800">{e.simulationName}</p>
                  <p className="text-xs text-slate-500 mt-0.5">Simulation Event · {e.date}</p>
                </div>
                <div className="text-right flex-shrink-0">
                  <p className={`text-xs font-semibold ${cfg.cls}`}>{e.status}</p>
                  <p className="text-xs text-slate-400 mt-0.5">{e.status === 'Clicked' ? 'Requires follow-up' : 'Recorded'}</p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default PhishingHistory;